module.exports = __webpack_public_path__ + "cirlce-bot-light.svg?faca543904f800f04ae354dbff82cdc2";